<div class="mat-modal-wrapper">
	<app-ehe-verification-modal
		(action)="actionFunction($event)"
		[title]="'Verify Email'"
		[button1]="'Verify'"
		[button2]="'Cancel'">
		<div class="container">
			<div class="row">
				<div class="col">
					<form [formGroup]="form">
						<div class="content text-center" *ngIf="!codeResent">
							Please enter the 6 digit verification code sent to {{ data.email }}
						</div>
						<div class="content text-center" *ngIf="codeResent">
							We have emailed you a new verification code. Please enter it below.
						</div>
						<div class="row justify-content-md-center padding-20">
							<div class="col-md-8">
								<mat-form-field class="w-100">
									<mat-label>Verification Code</mat-label>
									<input matInput value="" formControlName="code" maxlength="6" />
									<mat-hint>
										<span class="error" *ngIf="codeInvalid">The code you entered is invalid. Please enter again.</span>
									</mat-hint>
								</mat-form-field>
								<div class="small-text {{ codeInvalid ? 'pt-3' : '' }}">
									<span>Haven't you received your code? </span>
									<span (click)="resendVerificationCode()" class="link">Click here</span>
									<span> to resend verification code</span>
								</div>
							</div>
						</div>
					</form>
				</div>
			</div>
		</div>
	</app-ehe-verification-modal>
</div>
<app-ehe-spinner></app-ehe-spinner>
